<div id="content" class="dark help-page tv_help">
    <div >
        <img src="../../../../assets/img/app-logo-color.png" class="white-logo" />
        <img src="../../../../assets/img/app-logo.png" class="black-logo" />
        
        <h3>In case of any query or concerns, please E-mail us at</h3>
        
        <h4>support@prideplex.com</h4>
    </div>
</div>